import React from 'react';
import queryString from 'query-string';

import { Loading } from '_components';
import { session } from '_helpers';

class LoginPage extends React.Component {
  componentDidMount() {
    const { location: { search } } = this.props;
    const { redirect } = queryString.parse(search);

    session.userManager.signinRedirect({
      data: {
        path: redirect
      }
    });
  }

  render() {
    return (
      <Loading fullscreen />
    );
  }
}

export default LoginPage;
